import React from 'react'
import '../../../../App.scss';
import Grid from "@material-ui/core/Grid";
import Level from '../../../../assets/images/levels.png'
import Lock from '../../../../assets/images/ghofl.png'
class Badge extends React.Component{
    constructor() {
        super()
        this.state={
        }
    }
    componentDidMount() {

    }

    render() {
        const {data:{conditionValue,background}}=this.props
        return (
            <Grid  container alignItems={"center"} className='badge' style={{
                // position:'absolute',
                // width:'200%',
                backgroundColor:background,
                borderRadius:'30px'
            }}
                   justify={"center"}
            >
                <img className='badge-image' src={Level} alt=""/>
                    <p style={{position:'absolute'}} >{conditionValue===undefined?'undefined':conditionValue}</p>
                <img src={Lock} className='badge-lock'  alt=""/>
            </Grid>

        )
    }
}
export default Badge